var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChildCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42035 33.6115H0.607178V38.818H6.20762V38.0203H1.42035V33.6115ZM37.9048 33.6115V38.0203H33.1175V38.818H38.7179V33.6115H37.9048ZM0.608362 10.8662H1.42153V6.45832H6.20881V5.66064H0.608362V10.8662ZM33.1175 5.6607V6.45837H37.9048V10.8662H38.7179V5.6607H33.1175Z",
    fill: "#89C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51733 35.2821H31.4645V11.0186H8.51733V35.2821Z",
    fill: "#97B1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.875 35.1786H31.1429V10.75H15.875V35.1786Z",
    fill: "#648AEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7856 20.9286H13.8392V15.8394H10.7856V20.9286Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7856 31.1074H13.8392V26.0181H10.7856V31.1074Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9285 20.9286H22.9999V15.8394H18.9285V20.9286Z",
    fill: "#97B1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0178 20.9286H28.0893V15.8394H24.0178V20.9286Z",
    fill: "#97B1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9285 31.1074H22.9999V26.0181H18.9285V31.1074Z",
    fill: "#97B1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0178 31.1074H28.0893V26.0181H24.0178V31.1074Z",
    fill: "#97B1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71436 11.0186H33.2711V9.83545H6.71436V11.0186Z",
    fill: "#97B1F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5841,
    cy: 36.5986,
    rx: 7.44156,
    ry: 7.42333,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5844 29.1748C34.4735 29.1748 31.1428 32.4973 31.1428 36.5981C31.1428 40.6989 34.4735 44.0215 38.5844 44.0215C42.6952 44.0215 46.0259 40.6989 46.0259 36.5981C46.0259 32.4973 42.6952 29.1748 38.5844 29.1748ZM42.9053 37.4363C42.9053 37.6338 42.7432 37.7954 42.5452 37.7954H39.7846V40.5493C39.7846 40.7468 39.6226 40.9085 39.4246 40.9085H37.7442C37.5462 40.9085 37.3841 40.7468 37.3841 40.5493V37.7954H34.6236C34.4255 37.7954 34.2635 37.6338 34.2635 37.4363V35.76C34.2635 35.5625 34.4255 35.4008 34.6236 35.4008H37.3841V32.647C37.3841 32.4495 37.5462 32.2878 37.7442 32.2878H39.4246C39.6226 32.2878 39.7846 32.4495 39.7846 32.647V35.4008H42.5452C42.7432 35.4008 42.9053 35.5625 42.9053 35.76V37.4363Z",
    fill: "#3063E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildCompany);
export default __webpack_public_path__ + "static/media/childCompany.29b7d61fbd0658874acefce6f61a6da1.svg";
export { ForwardRef as ReactComponent };